<span class="data-table__content" [title]="params.value">{{ params.value }}</span>
